import {DomainType, PrivateRoutingType} from "@/api";
import {Form, FormNotification} from "@/utils/Form";
import {CreateDomainMutation, CreateDomainMutationVariables, useCreateDomainMutation} from "./mutations.generated";

const initialValues: CreateDomainMutationVariables = {
    domainType: DomainType.Business,
    name: "",
    description: "",
    dialoutPrefix: "",
    specialNumbersDialoutPrefix: "",
    shortNumbersLength: 4,
    preferDisplayNamesForStationNames: false,
    locationName: "",
    locationDescription: "",
    locationPilotNumber: "",
    smtpAuthEnabled: false,
    smtpUsername: "",
    smtpUserpass: "",
    privateRoutingType: PrivateRoutingType.GatewayWithPstnFallback,
    defaultUserPackage: undefined,
};

type CreateDomainFormType = Form<CreateDomainMutation, CreateDomainMutationVariables>;

export default class CreateDomainForm extends Form<CreateDomainMutation, CreateDomainMutationVariables> {
    constructor(
        successNotification: FormNotification<CreateDomainFormType>,
        errorNotification: FormNotification<CreateDomainFormType>,
    ) {
        super("createDomain");
        this.hooks(useCreateDomainMutation, initialValues, successNotification, errorNotification);
    }
}
